// extracted by mini-css-extract-plugin
module.exports = {"footer":"_footer_footer__2K5PA","footer_detail":"_footer_footer_detail__2kZxe"};